import { createAsyncThunk } from "@reduxjs/toolkit";
import { auditLogApi } from "../api/audit-log.api";
import type { ListAuditLogFilter } from "../domain/audit-log.types";
import { auditLogLoaded, auditLogRequestFailed, auditLogRequestStarted } from "./audit-log.slice";

function errorMessage(err: unknown): string {
  if (err instanceof Error) return err.message;
  return "Something went wrong";
}

export const fetchAuditLog = createAsyncThunk(
  "auditLog/fetch",
  async (filter: ListAuditLogFilter | void, { dispatch }) => {
    dispatch(auditLogRequestStarted());
    try {
      const entries = await auditLogApi.list(filter ?? undefined);
      dispatch(auditLogLoaded(entries));
    } catch (err) {
      dispatch(auditLogRequestFailed(errorMessage(err)));
      throw err;
    }
  },
);
